module.exports = __webpack_public_path__ + "img/message-btn.e3c9a969.png";